<template>
  <div class="container-fluid">
    <el-container>
      <el-header height="15%">
        <el-alert
          v-if="status === 200"
          :title="statusText"
          type="success"
          effect="dark"
        >
        </el-alert>
        <div class="row mt-4">
          <div class="col-md-2">
            <h4>Акции</h4>
          </div>
          <div class="col-md-2">
            <el-button type="success" @click="goToPage('promo-action/create')"
              >Создать акцию</el-button
            >
          </div>
        </div>
      </el-header>
      <el-main height="80%">
        <el-form aria-label="Поиск">
          <el-row>
            <el-col :span="8">
              <el-form-item label="Поиск по названию">
                <el-col :span="14">
                  <el-input
                    v-model="query.q"
                    @input="setQueryReset"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Поиск по тэгам">
                <el-col :span="14">
                  <el-select
                    clearable
                    filterable
                    multiple
                    v-model="query.tags"
                    @change="setQueryReset"
                  >
                    <el-option
                      v-for="item in tags"
                      :label="item.title"
                      :value="item.id"
                      :key="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Сортировка">
                <el-select
                  v-model="query.sort"
                  :width="300"
                  @change="setQuery"
                >
                  <el-option
                    value="title.asc"
                    label="Название (А-Я)"
                  ></el-option>
                  <el-option
                    value="title.desc"
                    label="Название (Я-А)"
                  ></el-option>
                  <el-option
                    value="priority.asc"
                    label="Приоритет по возрастанию"
                  ></el-option>
                  <el-option
                    value="priority.desc"
                    label="Приоритет по убыванию"
                  ></el-option>
                  <el-option
                    value="sort.asc"
                    label="Cортировка по возрастанию"
                  ></el-option>
                  <el-option
                    value="sort.desc"
                    label="Cортировка по убыванию"
                  ></el-option>
                  <el-option
                    value="activity.asc"
                    label="Активность по возрастанию"
                  ></el-option>
                  <el-option
                    value="activity.desc"
                    label="Активность по убыванию"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table :data="promoActions" style="width: 100%">
          <el-table-column prop="id" label="Id" width="50"> </el-table-column>
          <el-table-column prop="title" label="Название"> </el-table-column>
          <el-table-column label="Срок действия акции">
            <template slot-scope="scope">
              <p>
                {{ promoActions[scope.$index].date }}
              </p>
            </template>
          </el-table-column>
          >
          <el-table-column prop="sort" label="Сортировка"> </el-table-column>
          <el-table-column prop="priority" label="Приоритет"> </el-table-column>
          <el-table-column label="Активность">
            <template slot-scope="scope">
              <p v-if="!promoActions[scope.$index].activity">Нет</p>
              <p v-if="promoActions[scope.$index].activity">Да</p>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="Действия" width="400">
            <template slot-scope="scope">
              <el-button
                v-if="promoActions[scope.$index].activity"
                size="mini"
                type="primary"
                plain
                @click="(e) => hideRow(e, promoActions[scope.$index].id)"
              >
                Скрыть
              </el-button>
              <el-button
                v-if="!promoActions[scope.$index].activity"
                size="mini"
                type="primary"
                plain
                @click="(e) => restoreRow(e, promoActions[scope.$index].id)"
              >
                Восстановить
              </el-button>
              <el-button
              v-if="promoActions[scope.$index].activity"
                size="mini"
                class="action-table__update-btn"
                @click="(e) => updateRow(e, promoActions[scope.$index].id)"
                >Изменить
              </el-button>
              <el-button
                size="mini"
                type="danger"
                plain
                @click="deleteRow(promoActions[scope.$index].id)"
              >
                Удалить
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="5%">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="paginator.total"
          :current-page.sync="current"
          @current-change="getPage(current)"
          :hide-on-single-page="true"
          :page-size="paginator.per_page"
          :page-count="paginator.last_page"
        >
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import { SETPRELOADER_STATE } from "../../store/mutation-types.js";

export default {
  data: function () {
    return {
      promoActions: [],
      paginator: {
        total: 0,
        per_page: 0,
        last_page: 0,
      },
      status: 0,
      query: {
        q: null,
        tags: [],
        sort: '',
        page: 1,
        limit: 8
      },
      tags: [],
      current: 0,
      searchTimeout: null,
      statusText: "",
      makers: [],
    };
  },
  async mounted() {
    this.$store.commit(SETPRELOADER_STATE, true);

    await this.getActionsData()
      .then((response) => {
        const [tags, makers] = response;
        this.tags = tags.data;
        this.makers = makers.data;

        this.$store.dispatch("fetchAction", [{}, this.tags, this.makers]);
      })
      .catch((errors) => {
        if (errors.response.status === 401) {
          this.$router.push("/login");
        }
      })
      .finally(() => {
        this.$store.commit(SETPRELOADER_STATE, false);
      });

    this.initParams(this.$route.query);
    this.getPromoActions(this.getQuery(this.$route.query));
  },
   watch:{
    '$route.query'(v){   
      const query = this.getQuery(v)   
            if (query){              
                this.getPromoActions(query)
            }
        }
    },
  methods: {
    getActionsData() {
      return Promise.all([
        this.getTags(),
        this.getMakers(),        
      ]);
    },
    getTags() {
      return axios.get("/promo-action/tag");
    },
    getPromoActions(query = '') {
      this.$store.commit(SETPRELOADER_STATE, true);
      return axios.get(`/promo-action?${query}`).then((response) => {
            this.promoActions = response.data.data;
            this.paginator = response.data.meta;
            this.current = response.data.meta.current_page;
      }).finally(() => {
        this.$store.commit(SETPRELOADER_STATE, false);
      });
      
    },
    getMakers() {
      return axios.get("/promo-action/maker/");
    },
    searchActionsByName(e) {
      this.query.q = e;

      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = setTimeout(() => {
        if (!this.query.q) this.query.q = null

        this.$store.commit(SETPRELOADER_STATE, true);

        this.getPromoActions()
          .finally(() => {
            this.$store.commit(SETPRELOADER_STATE, false);
          });
      }, 500);
    },
    searchActionsByTags(e) {
      this.query.tags = e;

      this.$store.commit(SETPRELOADER_STATE, true);

      this.getPromoActions()
        .finally(() => {
          this.$store.commit(SETPRELOADER_STATE, false);
        });
    },
    handleClick() {
      console.log("click");
    },
    goToPage: function (path) {
      this.$router.push(path);
    },
    sortActions(value) {
      this.query.sort.by = value.split('.')[0]
      this.query.sort.order = value.split('.')[1]

      this.$store.commit(SETPRELOADER_STATE, true);

      this.getPromoActions()
        .finally(() => {
          this.$store.commit(SETPRELOADER_STATE, false);
        });
    },
    deleteRow (id) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      });

      axios
        .delete(`/promo-action/${id}`)
        .then((response) => {
          this.status = response.status;

          this.promoActions = [
            ...this.promoActions.filter((item) => item.id !== id),
          ];

          this.statusText = "Акция успешно удалена.";
        })
        .catch((errors) => {
          if (errors.response.status === 401) {
            this.$router.push("/login");
          } else {
            this.statusText = "Упс! Произошла ошибка, попробуйте заново.";
          }
        })
        .finally(() => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
        });
    },
    getTarget(e) {
      const t = e.target;

      return t.classList.contains("el-button") ? t : t.parentNode;
    },
    hideRow: function (e, id) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      });
      const btn = this.getTarget(e);

      btn.style.pointerEvents = "none";

      axios
        .post("/promo-action/" + id + "/hide")
        .then((response) => {
          this.status = response.status;

          this.promoActions = [
            ...this.promoActions.map((el) => {
              if (el.id === id) {
                el.activity = false;
              }

              return el;
            }),
          ];

          this.statusText = "Акция скрыта.";
        })
        .catch((errors) => {
          if (errors.response.status === 401) {
            this.$router.push("/login");
          } else {
            this.statusText = "Упс! Произошла ошибка, попробуйте заново.";
          }
        })
        .finally(() => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          btn.style.pointerEvents = "all";
        });
    },
    restoreRow: function (e, id) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      });

      const btn = this.getTarget(e);

      btn.style.pointerEvents = "none";

      axios
        .post("/promo-action/" + id + "/restore")
        .then((response) => {
          this.status = response.status;

          this.promoActions = [
            ...this.promoActions.map((el) => {
              if (el.id === id) {
                el.activity = true;
              }

              return el;
            }),
          ];

          this.statusText = "Акция восстановлена.";
        })
        .catch((errors) => {
          if (errors.response.status === 401) {
            this.$router.push("/login");
          } else {
            this.statusText = "Упс! Произошла ошибка, попробуйте заново.";
          }
        })
        .finally(() => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          btn.style.pointerEvents = "all";
        });
    },
    updateRow: function (e, id) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      });

      const btn = this.getTarget(e);

      btn.style.pointerEvents = "none";

      Promise.all([this.fetchAction(id), this.fetchActionProducts(id), this.fetchActionGifts(id)]).then((response) => {
        const [action, actionProducts, actionGifts ] = response

        this.$store.dispatch("fetchAction", [
          action.data,
          this.tags,
          this.makers,
          actionProducts.data,
          actionGifts.data,
        ]);
        
        this.$router.push(`/promo-action/${id}/update`);
      }).catch((errors) => {
        if (errors.response?.status === 401) {
          this.$router.push("/login");
        } else {
          this.statusText = "Упс! Произошла ошибка, попробуйте заново.";
        }
      })
      .finally(() => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          btn.style.pointerEvents = "all";
      })
    },
    fetchAction(id) {
      return axios.get(`/promo-action/${id}`)
    },
    fetchActionProducts(id) {
      return axios.get(`/promo-action/${id}/product`)
    },
    fetchActionGifts(id) {
      return axios.get(`/promo-action/${id}/gift-product`)
    },
    getPage: function (pageNum) {
      if (pageNum !== null) {
        this.query.page = pageNum;
        this.setQuery()
      }

      this.success = "";

      return this.paginator.first_page_url;
    },
    getSortObj(){
      const sortArr = this.query.sort.split('.')
      return {
        by: sortArr[0],
        order: sortArr[1]
      }
    },
    setQueryReset(){
        this.query.page = 1
        this.setQuery()
    },

    setQuery(){
        const result = {}
        let isChange = false;
        if (this.query.sort) {
            isChange = true
            const sort = this.getSortObj()
            result['sort']= {
                by: sort.by,
                order: sort.order
            } 
        }
        if (this.query.tags && this.query.tags.length > 0) {
            isChange = true
            result['tags']=this.query.tags
        }
        if (this.query.q) {
            isChange = true
            result['q']=this.query.q            
        }
        if(this.query.page){
            isChange = true
            result['page']=this.query.page
        }

        if (isChange) {
            const q = this.getQuery(result)
            this.$router.push({
              path: 'promo-actions' + q,
            })
        }
    }, 
    getQuery(query) {
        if (Object.keys(query).length > 0){        
            const qs = require('qs');
            return `?${qs.stringify(query)}`
        }
        return ''
    },
    initParams(query){
        if (!query){
            return
        }
        const qs = require('qs');
        const parseQuery= qs.parse(query);

        if (parseQuery.sort?.by && parseQuery.sort?.order) {
            this.query.sort = `${parseQuery.sort.by}.${parseQuery.sort.order}`
        }
        if (parseQuery.q){
            this.query.q = parseQuery.q
        }
        if (parseQuery.tags) {
            this.query.tags = parseQuery.tags.map((e) => Number.parseInt(e))
        }
        if (parseQuery.page){
            this.query.page = parseQuery.page
        }
    }
  },
};
</script>

<style scoped lang="scss">
  .action-table {
    &__update-btn {
      margin: 0 10px;
    }
  }
</style>